import { Box, Theme, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmptyTableIcon, NotFoundAssetIcon } from './Icons';
import Can from '@/app/Auth/Can';
import { Action, Subject } from '@/types/enums';

export type NoResultsOverlayProps = {
  isSuccess: boolean;
  isError: boolean;
};

const NoResultsOverlay = ({ isSuccess, isError }: NoResultsOverlayProps) => {
  const { t } = useTranslation();
  const theme = useTheme<Theme>();

  return isSuccess && !isError ? (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <EmptyTableIcon
        viewBox="0 0 64 64"
        style={{
          width: '64px',
          height: '64px',
        }}
        mode={theme.palette.mode}
      />
      <Typography
        component="h3"
        fontWeight="600"
        fontSize="16px"
        sx={(theme) => ({
          color: theme.palette.text.primary,
          margin: '12px 0',
        })}
      >
        {t('searchBar.notResultsFound')}
      </Typography>
      <Typography
        component="p"
        fontSize="14px"
        sx={(theme) => ({ color: theme.palette.text.secondary })}
      >
        {t('searchBar.notResultsFoundHelp')}
      </Typography>
      <Typography
        component="p"
        fontSize="14px"
        sx={(theme) => ({ color: theme.palette.text.secondary })}
      >
        {t('global.noResultsFoundExample')}
      </Typography>
    </Box>
  ) : (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <NotFoundAssetIcon
        viewBox="0 0 64 64"
        style={{
          width: '64px',
          height: '64px',
        }}
        mode={theme.palette.mode}
      />
      <Typography
        component="h3"
        fontWeight="600"
        fontSize="16px"
        sx={(theme) => ({
          color: theme.palette.text.primary,
          margin: '12px 0',
        })}
      >
        {t('global.noResultsFound')}
      </Typography>
      <Typography
        component="p"
        fontSize="14px"
        sx={(theme) => ({ color: theme.palette.text.secondary })}
      >
        {`${t('searchBar.enterVinLabel')}${
          Can(Action.READ, Subject.stock_number) ? t('searchBar.stock') : ''
        }${
          Can(Action.READ, Subject.work_order) ? t('searchBar.workOrder') : ''
        } ${
          Can(Action.READ, Subject.seller_id) ? t('searchBar.sellerId') : ''
        } ${t('global.noResultsFoundSubtitle')}`}
      </Typography>
      <Typography
        component="p"
        fontSize="14px"
        sx={(theme) => ({ color: theme.palette.text.secondary })}
      >
        {t('global.noResultsFoundExample')}
      </Typography>
    </Box>
  );
};

export default NoResultsOverlay;
